"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(o, i) {
  return o.interfaces_ && o.interfaces_.indexOf(i) > -1;
}